import { createAuthorizationHeaderValue } from 'lib-shared-auth';
import { config } from 'lib-shared-backend-config';

type AuthHeader = {
  Authorization: string;
};

type CacheControlHeader = {
  'Cache-Control': 'no-cache';
  Pragma: 'no-cache';
};

export function isPrivateFilesAPI(filePath: string): boolean {
  return filePath.includes(
    `${config.url.files.replace('https://', '').replace('/', '')}/private`,
  );
}

export async function getFileHeaders(
  isPrivateFile: boolean,
): Promise<AuthHeader | CacheControlHeader> {
  return isPrivateFile
    ? {
        Authorization: await createAuthorizationHeaderValue(),
      }
    : {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      };
}

// `/v2/search` does not seem to provide a valid nb_pages value, so calculate on frontend.
export const getNbPages = (result: {
  nb_hits: number;
  hits_per_page: number;
  nb_pages: number;
}): number => {
  const { nb_hits, hits_per_page, nb_pages } = result;
  if (nb_pages !== 0) {
    return nb_pages;
  }

  return Math.ceil(nb_hits / hits_per_page) || nb_pages;
};
